{
  "home": "Resident pages",
  "contract": "Agreement",
  "defectNotice": "Fault report",
  "confirmContractTermination": "Confirm the termination",
  "messages": "Messages",
  "feedback": "Feedback",
  "paymentHistory": "Payment history",
  "paymentInformation": "Invoices and payment details",
  "terminateContract": "Terminate the agreement",
  "contractModification": "Contract modifications",
  "documents": "Documents",
  "userInfo": "User information",
  "notFound": "Page not found",
  "bulletin": "Bulletin",
  "building": "Property information",
  "bulletinBoard": "All bulletins",
  "contactInformation": "Contact Information",
  "parking": "Parking spots",
  "gymBooking": "Gym Bookings",
  "gymReservations": "Gym Reservations",
  "laundryReservations": "Laundry Reservations",
  "saunaReservations": "Sauna Reservations",
  "commonAreaReservations": "Common Area Reservations",
  "storages": "Storages"
}
